import * as React from 'react';
import Button from 'react-bootstrap/Button';
import { Col, Row, Form, Spinner } from 'react-bootstrap';

import { IUEFADeclarationProps } from './interfaces/IUEFADeclarationProps';
import { IUEFADeclarationState } from './interfaces/IUEFADeclarationState';
import { IUEFAForm, IUEFAFormDocument } from './interfaces/IUEFAForm';
import './UEFADeclarationFormStyle.scss';
import UEFADeclarationService from './UEFADeclarationService';

class UEFADeclarationForm extends React.Component<IUEFADeclarationProps, IUEFADeclarationState> {
    constructor(props: any) {
        super(props);

        this.state = {
            NoFormRequired: 0,
            validated: false,
            disableForm: false,
            processingForm: false,
            validateOpposition: false,
            validateTicketHolder: false,
            validateYourName: false,
            validateConfirmAllFields: false
        }
    }

    public async componentDidMount() {
        document.title = "CFC | UEFA Declaration Form";
    }

    public render() {
        const { NoFormRequired, validated, disableForm, validateOpposition, validateTicketHolder, validateYourName, validateConfirmAllFields, processingForm } = this.state;
        return (
            <Row className="pgRow">
                <h2 className="subTitle">UEFA Declaration Form</h2>
                <p className="marginTop20 leadingPara">You are reminded that all tickets issued by, or on behalf of, Chelsea FC are subject to Chelsea FC's Conditions of Issue
                    and Ground Regulations, available at <a href="https://www.chelseafc.com/tickets/conditionsofissue" target="_blank" rel="noreferrer">Conditions of Issue</a>
                    <br /><br />
                    Your data will be used for the purpose of administering and fulfilling your ticket purchase for this match.</p>

                <div className="marginTop10" style={{ display: NoFormRequired > 0 ? 'none' : 'block' }}>
                    <Form>
                        <Form.Row>
                            <Form.Label style={{ textDecoration: 'underline', fontWeight: 'bold' }}>Declaration form submission</Form.Label>
                        </Form.Row>
                        <Form.Row id="divDeclarationWrapper">
                            <Form.Label>
                                Each supporter will need to fully complete an online declaration form once the booking has been made.
                                The declaration form must be completed accurately including the passport number of each applicant.
                                Supporters who order two tickets or more in one transaction will be required to submit the declaration forms for
                                that transaction at the same time in order to sit together.
                            </Form.Label>
                        </Form.Row>
                        <Form.Row className="marginTop10">
                            <Col xs="auto">
                                <Form.Control id="tbNoFormReq" type="number" className="tbNoForm" min={1} defaultValue="1" max={100} />
                            </Col>
                            <Col xs="auto">
                                <Button className="btnCFCBrand" onClick={this.onNoFormRequired}>Confirm</Button>
                            </Col>
                            <Col xs="auto" id="divSpinner" className="hideLbl">
                                <Spinner animation="border" variant="primary" className="marginLeft5" />
                                &nbsp;
                                <label className="colourGray loadingVerticalAlign">Loading...</label>
                            </Col>
                        </Form.Row>
                    </Form>
                    <div id="divFormReqVal" className="hideLbl marginTop10"></div>
                </div>

                <div id="divFormDisplay" className="marginTop20" style={{ display: NoFormRequired > 0 ? 'block' : 'none' }}>
                    <Form noValidate validated={validated} onSubmit={this.onSubmitForm}>
                        <Form.Row>
                            <Form.Label column sm={2}>Opposition</Form.Label>
                            <Col sm={10} className="tbHeadForm">
                                <Form.Control id="drpOpposition" name="drpOpposition" as="select" required isInvalid={validateOpposition} disabled={disableForm}>
                                    <option value="0">Select...</option>
                                </Form.Control>
                                <Form.Control.Feedback type="invalid">Please select Opposition</Form.Control.Feedback>
                            </Col>
                        </Form.Row>
                        <Form.Row className="marginTop10">
                            <Form.Label column sm={2}>I am</Form.Label>
                            <Col sm={10} className="tbHeadForm">
                                <Form.Control id="drpTicketHolder" name="drpTicketHolder" as="select" required isInvalid={validateTicketHolder} disabled={disableForm}>
                                    <option value=''>Please select...</option>
                                    <option value='HospitalityOption'>Hospitality Season Ticket Holder</option>
                                    <option value='GeneralAdmin'>General Admission Season Ticket Holder/Member</option>
                                </Form.Control>
                                <Form.Control.Feedback type="invalid">Please select an option</Form.Control.Feedback>
                            </Col>
                        </Form.Row>
                        <Form.Row id="formRowWrapper" className="marginTop20">
                            {this.onBuildFormGroup(NoFormRequired)}
                        </Form.Row>
                        <p className="subtitle marginTop20">Declaration</p>
                        <Form.Row>
                            <Form.Label column sm={2}>Your name</Form.Label>
                            <Col sm={10} className="tbHeadForm">
                                <Form.Control id="tbYourName" type="text" required isInvalid={validateYourName} disabled={disableForm} />
                                <Form.Control.Feedback type="invalid">Your name is required</Form.Control.Feedback>
                            </Col>
                        </Form.Row>
                        <Form.Group as={Row} controlId="formCompletedAllFields" className="marginTop30 paddingLeft15">
                            <Form.Check id="chkConfirmAllFields" required isInvalid={validateConfirmAllFields} disabled={disableForm}
                                label="I confirm that: - The above details are accurate and correct; the match ticket is for my own personal use; and I have read and understood the ticket collection procedure and understand that a ticket will not be issued to me if that procedure is not followed. - I understand that my purchase and use of a match ticket will be subject to the Chelsea FC Conditions of Issue available www.chelseafc.com/tickets/conditionsofissue" />
                        </Form.Group>
                        <Form.Row className="btnSubmitRow">
                            <Button type="submit" className="btnCFCBrand btnSubmit" block disabled={disableForm}>Submit</Button>
                            {
                                processingForm &&
                                <Spinner animation="border" variant="primary" className="marginLeft5" />
                            }
                            <div id="divSubmitStatus" className="hideLbl"></div>
                        </Form.Row>
                    </Form>
                </div>

            </Row>
        );
    }

    private onNoFormRequired = async () => {
        const tbVal = document.getElementById('tbNoFormReq') as HTMLInputElement;
        const val = tbVal === undefined ? '' : tbVal.value.trim();
        if (val.length > 0 && typeof parseInt(val) === 'number') {
            const divFormReqVal = document.getElementById('divFormReqVal') as HTMLDivElement;
            if (Number(val) > 100) {
                divFormReqVal.innerText = "Maximum value is 100";
                divFormReqVal.className = "showLbl marginTop10";
                divFormReqVal.style.color = "red";
            } else {
                //Fetch opposition value(s) from backend...
                const divSpinner = document.getElementById('divSpinner') as HTMLDivElement;
                divSpinner.className = "showLbl";

                await UEFADeclarationService.getUEFAOppositionMatches((result: string, isSuccess: boolean) => {
                    if (isSuccess && result.length > 0) {
                        divSpinner.className = "hideLbl";

                        var parsed = JSON.parse(result)
                        console.log(parsed);

                        const drpOpposition = document.getElementById('drpOpposition') as HTMLSelectElement;
                        for (let i = 0; i < parsed.length; i++) {
                            let opt = document.createElement('option');

                            console.log(parsed[i])

                            // const test = JSON.parse(result[i]);

                            opt.value = parsed[i].new_matchid;
                            opt.textContent = parsed[i].new_name;
                            drpOpposition.appendChild(opt);
                        }
                        divFormReqVal.className = "hideLbl marginTop10";
                        this.setState({ NoFormRequired: Number(val) });
                    } else {
                        divFormReqVal.innerText = result;
                        divFormReqVal.className = "showLbl marginTop10";
                        divFormReqVal.style.color = "red";
                        divSpinner.className = "hideLbl";
                    }
                });

                // await UEFADeclarationService.getUEFAOpposition('UEFADeclarationTeams', (result: string, isSuccess: boolean) => {
                //     if (isSuccess && result.length > 0) {
                //         divSpinner.className = "hideLbl";

                //         const splitResult = result.split(',');
                //         const drpOpposition = document.getElementById('drpOpposition') as HTMLSelectElement;
                //         for (let i = 0; i < splitResult.length; i++) {
                //             let opt = document.createElement('option');
                //             opt.value = splitResult[i];
                //             opt.textContent = splitResult[i];
                //             drpOpposition.appendChild(opt);
                //         }
                //         divFormReqVal.className = "hideLbl marginTop10";
                //         this.setState({ NoFormRequired: Number(val) });
                //     } else {
                //         divFormReqVal.innerText = result;
                //         divFormReqVal.className = "showLbl marginTop10";
                //         divFormReqVal.style.color = "red";
                //         divSpinner.className = "hideLbl";
                //     }
                // });
            }
        }
    }

    private onBuildFormGroup = (totalForm: number): JSX.Element[] => {
        const formContent: JSX.Element[] = [];

        for (let i = 0; i < totalForm; i++) {
            formContent.push(
                <div key={i} className="divFormWrapper">
                    <p className="formTitle">Form {i + 1}</p>
                    <Col>
                        <Form.Group as={Row}>
                            <Form.Label column sm={4}>First Name</Form.Label>
                            <Col sm={8}>
                                <Form.Control id={'tbFirstName' + i} type="text" required />
                                <Form.Control.Feedback type="invalid">First Name required</Form.Control.Feedback>
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row}>
                            <Form.Label column sm={4}>Surname</Form.Label>
                            <Col sm={8}>
                                <Form.Control id={'tbSurname' + i} type="text" required />
                                <Form.Control.Feedback type="invalid">Surname required</Form.Control.Feedback>
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row}>
                            <Form.Label column sm={4}>Email</Form.Label>
                            <Col sm={8}>
                                <Form.Control id={'tbEmail' + i} type="email" required />
                                <Form.Control.Feedback type="invalid">Email required</Form.Control.Feedback>
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} className="divDOB">
                            <Form.Label column sm={6}>Date of birth</Form.Label>
                            <Col sm={6}>
                                <Form.Control id={'tbDOB' + i} type="date" required placeholder="dd/mm/yyyy" className="tbDOB" />
                                <Form.Control.Feedback type="invalid">Date of birth required</Form.Control.Feedback>
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row}>
                            <Form.Label column sm={4}>Place of birth</Form.Label>
                            <Col sm={8}>
                                <Form.Control id={'tbPlaceOfBirth' + i} type="text" required placeholder="City or Town" />
                                <Form.Control.Feedback type="invalid">Place of birth required</Form.Control.Feedback>
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row}>
                            <Form.Label column sm={6}>Gender</Form.Label>
                            <Col sm={6}>
                                <Form.Control id={'drpGender' + i} as="select" required>
                                    <option value=''>Please select...</option>
                                    <option value='M'>Male</option>
                                    <option value='F'>Female</option>
                                </Form.Control>
                                <Form.Control.Feedback type="invalid">Gender required</Form.Control.Feedback>
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row}>
                            <Form.Label column sm={4}>Country of residence</Form.Label>
                            <Col sm={8}>
                                <Form.Control id={'tbCountryResidence' + i} type="text" required />
                                <Form.Control.Feedback type="invalid">Country of residence required</Form.Control.Feedback>
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row}>
                            <Form.Label column sm={4}>Telephone Number</Form.Label>
                            <Col sm={8}>
                                <Form.Control id={'tbTelephone' + i} type="number" required />
                                <Form.Control.Feedback type="invalid">Telephone required or incorrect format</Form.Control.Feedback>
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row}>
                            <Form.Label column sm={4}>Passport Number</Form.Label>
                            <Col sm={8}>
                                <Form.Control id={'tbPassportNo' + i} type="text" required />
                                <Form.Control.Feedback type="invalid">Passport Number required</Form.Control.Feedback>
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row}>
                            <Form.Label column sm={4}>Nationality</Form.Label>
                            <Col sm={8}>
                                <Form.Control id={'tbNationality' + i} type="text" required />
                                <Form.Control.Feedback type="invalid">Nationality required</Form.Control.Feedback>
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row}>
                            <Form.Label column sm={4}>Season Ticket / Membership No</Form.Label>
                            <Col sm={8}>
                                <Form.Control id={'tbSeasonTicket' + i} type="text" required />
                                <Form.Control.Feedback type="invalid">Ticket/Membership No required</Form.Control.Feedback>
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row}>
                            <Form.Label column sm={6}>Supporter Number that purchased the ticket(s)</Form.Label>
                            <Col sm={6}>
                                <Form.Control id={'tbSupporterNo' + i} type="text" required />
                                <Form.Control.Feedback type="invalid">Supporter No required</Form.Control.Feedback>
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row}>
                            <Form.Label column sm={6}>Estimated Arrival Date</Form.Label>
                            <Col sm={6}>
                                <Form.Control id={'tbFormDate' + i} type="date" required placeholder="dd/mm/yyyy" />
                                <Form.Control.Feedback type="invalid">Arrival Date required</Form.Control.Feedback>
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row}>
                            <Form.Label column sm={6}>Estimated Arrival Time</Form.Label>
                            <Col sm={6}>
                                <Form.Control id={'tbFormTime' + i} type="time" required placeholder="hh:mm" />
                                <Form.Control.Feedback type="invalid">Arrival Time required</Form.Control.Feedback>
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row}>
                            <Form.Label column sm={6}>Method of Travel</Form.Label>
                            <Col sm={6}>
                                <Form.Control id={'drpFormTravel' + i} as="select" required onChange={() => this.onMethodOfTravel(i)}>
                                    <option value=''>Please select ...</option>
                                    <option>Car</option>
                                    <option>Boat</option>
                                    <option>Train</option>
                                    <option>Plane</option>
                                </Form.Control>
                                <Form.Control.Feedback type="invalid">Travel method required</Form.Control.Feedback>
                            </Col>
                        </Form.Group>
                        <Form.Group id={`flightDivGroup${i}`} as={Row}>
                            <Form.Label column sm={4}>Flight Number</Form.Label>
                            <Col sm={8}>
                                <Form.Control id={'tbFlightNo' + i} type="text" required />
                                <Form.Control.Feedback type="invalid">Flight Number required</Form.Control.Feedback>
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row}>
                            <Form.Label column sm={6}>Booking Ref/Confirmation Number</Form.Label>
                            <Col sm={6}>
                                <Form.Control id={'tbConfirmationNumber' + i} type="text" required />
                                <Form.Control.Feedback type="invalid">Confirmation Number required</Form.Control.Feedback>
                            </Col>
                        </Form.Group>
                    </Col>
                </div>
            );
        }
        return formContent;
    }

    private onClubTicketHolderChange = (event: any) => {
        let tbValEnabled = false;
        if (event.target.value === 'HospitalityOption') {
            tbValEnabled = true;
        }
        const tbDOB = document.getElementsByClassName('tbDOB');
        if (tbDOB.length > 0) {
            for (let i = 0; i < tbDOB.length; i++) {
                const tb = tbDOB[i] as HTMLInputElement;
                tb.required = tbValEnabled;
            }

            const divDOB = document.getElementsByClassName('divDOB');
            for (let i = 0; i < divDOB.length; i++) {
                const tb = divDOB[i] as HTMLDivElement;
                tb.style.display = tbValEnabled ? 'flex' : 'none';
            }
        }
    }

    private onMethodOfTravel = (index: number) => {
        const drpFormTravel = document.getElementById(`drpFormTravel${index}`) as HTMLSelectElement;
        const flightDivGroup = document.getElementById(`flightDivGroup${index}`) as HTMLDivElement;
        const tbFlightNo = document.getElementById(`tbFlightNo${index}`) as HTMLInputElement;
        if (drpFormTravel.options[drpFormTravel.selectedIndex].text === 'Plane' || drpFormTravel.selectedIndex === 0) {
            flightDivGroup.style.display = "flex";
            tbFlightNo.required = true;
        } else {
            flightDivGroup.style.display = "none";
            tbFlightNo.required = false;
        }
    }

    private onSubmitForm = (event: any) => {
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            //Validation feedback labels don't work out of the box, so using state 
            //approach that set status of invalid property of required form controls
            this.ValidationFeedbacks();
        } else {
            //Switch off any feedback display that could be on display
            this.setState({
                validateOpposition: false, validateTicketHolder: false, validateYourName: false,
                validateConfirmAllFields: false, disableForm: true, processingForm: true
            }, async () => {
                const formRow = document.getElementById('formRowWrapper') as HTMLTableRowElement;
                formRow.style.pointerEvents = "none";
                formRow.style.opacity = "0.5";

                const divSubmitStatus = document.getElementById('divSubmitStatus') as HTMLDivElement;
                divSubmitStatus.innerText = "";

                //Also reset (hide) any feedback labels on forms that may be on display and then return form values
                const getFormData = this.ValidateFeedbackForms(false, true);

                if (getFormData as IUEFAForm[]) {
                    if ((getFormData as IUEFAForm[]).length > 0) {

                        const opposition = document.getElementById('drpOpposition') as HTMLSelectElement;
                        const ticketHolder = document.getElementById('drpTicketHolder') as HTMLSelectElement;

                        const payload: IUEFAFormDocument = {
                            Opposition: opposition.options[opposition.selectedIndex].text,
                            MatchId:    opposition.options[opposition.selectedIndex].value,
                            TicketHolder: ticketHolder.options[ticketHolder.selectedIndex].value,
                            Form: getFormData as IUEFAForm[],
                            YourName: (document.getElementById('tbYourName') as HTMLInputElement).value.trim()
                        };

                        await UEFADeclarationService.submitUEFADeclaration(payload, (result: string, isSuccess: boolean) => {
                            if (isSuccess) {
                                this.setState({ processingForm: false }, () => {
                                    divSubmitStatus.className = "marginTop10 showLbl success";
                                    divSubmitStatus.innerText = result;
                                });
                            } else {
                                this.setState({ disableForm: false, processingForm: false }, () => {
                                    divSubmitStatus.className = "marginTop10 showLbl errorText";
                                    divSubmitStatus.innerText = result;

                                    formRow.style.opacity = "1.0";
                                    formRow.style.pointerEvents = "auto";
                                });
                            }
                        });

                    }
                }
            });
        }

        event.preventDefault();
        event.stopPropagation();

    }

    private ValidationFeedbacks = () => {

        let stateValidateYourName = false;
        let stateOpposition = false;
        let stateTicketHolder = false;
        let stateConfirmAllFields = false;
        let focusSetAlready = false;

        const drpOpposition = document.getElementById('drpOpposition') as HTMLSelectElement;
        if (drpOpposition.selectedIndex === 0) {
            stateOpposition = true;
            focusSetAlready = true;
            drpOpposition.focus();
        }

        const drpTicketHolder = document.getElementById('drpTicketHolder') as HTMLSelectElement;
        if (drpTicketHolder.selectedIndex === 0) {
            stateTicketHolder = true;
            focusSetAlready = true;
            drpTicketHolder.focus();
        }

        const tbYourName = document.getElementById('tbYourName') as HTMLInputElement;
        const yourName = tbYourName.value === undefined ? '' : tbYourName.value.trim();
        if (yourName.length === 0) {
            stateValidateYourName = true;
            if (!focusSetAlready) {
                focusSetAlready = true;
                tbYourName.focus();
            }
        }

        const chkConfirmAllFields = document.getElementById('chkConfirmAllFields') as HTMLInputElement;
        if (!chkConfirmAllFields.checked)
            stateConfirmAllFields = true

        this.setState({
            validateOpposition: stateOpposition, validateTicketHolder: stateTicketHolder,
            validateYourName: stateValidateYourName, validateConfirmAllFields: stateConfirmAllFields
        });

        this.ValidateFeedbackForms(focusSetAlready, false);
    }

    private ValidateFeedbackForms = (focusStatus: boolean, hasPassedValidateion: boolean) => {
        const formsUI = document.getElementsByClassName('divFormWrapper') as HTMLCollectionOf<Element>;
        const formData: IUEFAForm[] = [];

        if (formsUI.length > 0) {
            for (let i = 0; i < formsUI.length; i++) {

                //First Name
                const tbFirstName = document.getElementById(`tbFirstName${i}`) as HTMLInputElement;
                const firstName = tbFirstName.value === undefined ? '' : tbFirstName.value.trim();
                if (firstName.length === 0) {
                    tbFirstName.className = 'form-control form-control-sm is-invalid';
                    if (!focusStatus) {
                        focusStatus = true;
                        tbFirstName.focus();
                    }
                } else {
                    tbFirstName.className = 'form-control form-control-sm';
                }

                //Surname
                const tbSurname = document.getElementById(`tbSurname${i}`) as HTMLInputElement;
                const surname = tbSurname.value === undefined ? '' : tbSurname.value.trim();
                if (surname.length === 0) {
                    tbSurname.className = 'form-control form-control-sm is-invalid';
                    if (!focusStatus) {
                        focusStatus = true;
                        tbSurname.focus();
                    }
                } else {
                    tbSurname.className = 'form-control form-control-sm';
                }

                //Email
                const tbEmail = document.getElementById(`tbEmail${i}`) as HTMLInputElement;
                const email = tbEmail.value === undefined ? '' : tbEmail.value.trim();
                if (email.length === 0) {
                    tbEmail.className = 'form-control form-control-sm is-invalid';
                    if (!focusStatus) {
                        focusStatus = true;
                        tbEmail.focus();
                    }
                } else {
                    tbEmail.className = 'form-control form-control-sm';
                }


                //Date of birth
                const tbDOB = document.getElementById(`tbDOB${i}`) as HTMLInputElement;
                const dob = tbDOB.value === undefined ? '' : tbDOB.value.trim();
                if (dob.length === 0) {
                    tbDOB.className = 'tbDOB form-control form-control-sm is-invalid';
                    if (!focusStatus) {
                        focusStatus = true;
                        tbDOB.focus();
                    }
                } else {
                    tbDOB.className = 'tbDOB form-control form-control-sm';
                }

                //Gender
                const drpGender = document.getElementById(`drpGender${i}`) as HTMLSelectElement;
                if (drpGender.selectedIndex === 0) {
                    drpGender.className = 'form-control form-control-sm is-invalid';
                    if (!focusStatus) {
                        focusStatus = true;
                        drpGender.focus();
                    }
                } else {
                    drpGender.className = 'form-control form-control-sm';
                }

                //Place of birth
                const tbPlaceOfBirth = document.getElementById(`tbPlaceOfBirth${i}`) as HTMLInputElement;
                const placeOfBirth = tbPlaceOfBirth.value === undefined ? '' : tbPlaceOfBirth.value.trim();
                if (placeOfBirth.length === 0) {
                    tbPlaceOfBirth.className = 'form-control form-control-sm is-invalid';
                    if (!focusStatus) {
                        focusStatus = true;
                        tbPlaceOfBirth.focus();
                    }
                } else {
                    tbPlaceOfBirth.className = 'form-control form-control-sm';
                }

                //Country of residence
                const tbCountryResidence = document.getElementById(`tbCountryResidence${i}`) as HTMLInputElement;
                const countryResidence = tbCountryResidence.value === undefined ? '' : tbCountryResidence.value.trim();
                if (countryResidence.length === 0) {
                    tbCountryResidence.className = 'form-control form-control-sm is-invalid';
                    if (!focusStatus) {
                        focusStatus = true;
                        tbCountryResidence.focus();
                    }
                } else {
                    tbCountryResidence.className = 'form-control form-control-sm';
                }

                //Telephone Number
                const tbTelephone = document.getElementById(`tbTelephone${i}`) as HTMLInputElement;
                const telephone = tbTelephone.value === undefined ? '' : tbTelephone.value.trim();
                if (telephone.length === 0 || telephone.length < 10 || telephone.charAt(0) === '-') {
                    tbTelephone.className = 'form-control form-control-sm is-invalid';
                    if (!focusStatus) {
                        focusStatus = true;
                        tbTelephone.focus();
                    }
                } else {
                    tbTelephone.className = 'form-control form-control-sm';
                }

                //Passport Number
                const tbPassportNo = document.getElementById(`tbPassportNo${i}`) as HTMLInputElement;
                const passportNo = tbPassportNo.value === undefined ? '' : tbPassportNo.value.trim();
                if (passportNo.length === 0) {
                    tbPassportNo.className = 'form-control form-control-sm is-invalid';
                    if (!focusStatus) {
                        focusStatus = true;
                        tbPassportNo.focus();
                    }
                } else {
                    tbPassportNo.className = 'form-control form-control-sm';
                }

                //Nationality
                const tbNationality = document.getElementById(`tbNationality${i}`) as HTMLInputElement;
                const nationality = tbNationality.value === undefined ? '' : tbNationality.value.trim();
                if (nationality.length === 0) {
                    tbNationality.className = 'form-control form-control-sm is-invalid';
                    if (!focusStatus) {
                        focusStatus = true;
                        tbNationality.focus();
                    }
                } else {
                    tbNationality.className = 'form-control form-control-sm';
                }

                //Season Ticket / Membership No
                const tbSeasonTicket = document.getElementById(`tbSeasonTicket${i}`) as HTMLInputElement;
                const seasonTicket = tbSeasonTicket.value === undefined ? '' : tbSeasonTicket.value.trim();
                if (seasonTicket.length === 0) {
                    tbSeasonTicket.className = 'form-control form-control-sm is-invalid';
                    if (!focusStatus) {
                        focusStatus = true;
                        tbSeasonTicket.focus();
                    }
                } else {
                    tbSeasonTicket.className = 'form-control form-control-sm';
                }

                //Supporter Number
                const tbSupporterNo = document.getElementById(`tbSupporterNo${i}`) as HTMLInputElement;
                const supporterNo = tbSupporterNo.value === undefined ? '' : tbSupporterNo.value.trim();
                if (supporterNo.length === 0) {
                    tbSupporterNo.className = 'form-control form-control-sm is-invalid';
                    if (!focusStatus) {
                        focusStatus = true;
                        tbSupporterNo.focus();
                    }
                } else {
                    tbSupporterNo.className = 'form-control form-control-sm';
                }

                //Estimated Arrival Date
                const tbFormDate = document.getElementById(`tbFormDate${i}`) as HTMLInputElement;
                const formDate = tbFormDate.value === undefined ? '' : tbFormDate.value.trim();
                if (formDate.length === 0) {
                    tbFormDate.className = 'form-control form-control-sm is-invalid';
                    if (!focusStatus) {
                        focusStatus = true;
                        tbFormDate.focus();
                    }
                } else {
                    tbFormDate.className = 'form-control form-control-sm';
                }

                //Estimated Arrival Time
                const tbFormTime = document.getElementById(`tbFormTime${i}`) as HTMLInputElement;
                const formTime = tbFormTime.value === undefined ? '' : tbFormTime.value.trim();
                if (formTime.length === 0) {
                    tbFormTime.className = 'form-control form-control-sm is-invalid';
                    if (!focusStatus) {
                        focusStatus = true;
                        tbFormTime.focus();
                    }
                } else {
                    tbFormTime.className = 'form-control form-control-sm';
                }

                //Method of Travel
                const drpFormtravel = document.getElementById(`drpFormTravel${i}`) as HTMLSelectElement;
                if (drpFormtravel.selectedIndex === 0) {
                    drpFormtravel.className = 'form-control form-control-sm is-invalid';
                    if (!focusStatus) {
                        focusStatus = true;
                        drpFormtravel.focus();
                    }
                } else {
                    drpFormtravel.className = 'form-control form-control-sm';
                }

                //Flight Number
                const tbFlightNo = document.getElementById(`tbFlightNo${i}`) as HTMLInputElement;
                const flightNo = tbFlightNo.value === undefined ? '' : tbFlightNo.value.trim();
                if (drpFormtravel.options[drpFormtravel.selectedIndex].text === 'Plane' && flightNo.length === 0) {
                    tbFlightNo.className = 'form-control form-control-sm is-invalid';
                    if (!focusStatus) {
                        focusStatus = true;
                        tbFlightNo.focus();
                    }
                } else {
                    tbFlightNo.className = 'form-control form-control-sm';
                }

                //Confirmation Number
                const tbConfirmationNumber = document.getElementById(`tbConfirmationNumber${i}`) as HTMLInputElement;
                const confirmationNumber = tbConfirmationNumber.value === undefined ? '' : tbConfirmationNumber.value.trim();
                if (confirmationNumber.length === 0) {
                    tbConfirmationNumber.className = 'form-control form-control-sm is-invalid';
                    if (!focusStatus) {
                        focusStatus = true;
                        tbConfirmationNumber.focus();
                    }
                } else {
                    tbConfirmationNumber.className = 'form-control form-control-sm';
                }

                if (hasPassedValidateion) {
                    //new Date(formDate + ' ' + formTime).toLocaleString('en-GB')
                    const parseTravelDate = new Date(formDate);
                    const parseDOB = new Date(dob);
                    formData.push({
                        FirstName: firstName.toUpperCase(),
                        Surname: surname.toUpperCase(),
                        Email: email,
                        DateOfBirth: `${this.dateFormat(parseDOB.getDate())}/${this.dateFormat((parseDOB.getMonth() + 1))}/${parseDOB.getFullYear()}`,
                        PassportNo: passportNo,
                        Nationality: nationality,
                        SeasonTicketNo: seasonTicket,
                        SupporterNo: supporterNo,
                        EstimatedArrival: `${this.dateFormat(parseTravelDate.getDate())}/${this.dateFormat((parseTravelDate.getMonth() + 1))}/${parseTravelDate.getFullYear()} ${formTime}`,
                        MethodTravel: drpFormtravel.options[drpFormtravel.selectedIndex].text,
                        FlightNo: flightNo,
                        PlaceOfBirth: placeOfBirth,
                        Gender: drpGender.options[drpGender.selectedIndex].value,
                        CountryOfResidence: countryResidence,
                        Telephone: telephone,
                        ConfirmationNo:confirmationNumber 
                    });
                }
            }

            if (hasPassedValidateion)
                return formData;
        }
        return null;
    }

    private dateFormat = (value: number) => {
        if (value < 10)
            return `0${value}`;
        else
            return value.toString();
    }
}

export default UEFADeclarationForm;